import { useCallback } from "react";

const sortParamMap = {
    "locationInfo.locationId": "locationInfo.location",
    assignedUserInfo: "assignedUserInfo.FullName",
    assignmentGroupKey: "assignmentGroupName",
    fullName: "assignedUserInfo.fullName",
};

export const useTransformSortParams = () => {
    return useCallback((originalSort) => {
        return (
            originalSort &&
            originalSort.map(({ id, desc }) => {
                const columnName = sortParamMap[id] || id;

                return {
                    columnName,
                    sortOrder: desc ? "desc" : "asc",
                };
            })
        );
    }, []);
};
